/**
 * Broker & bundle metadata (shared client-side).
 * Bundle order and slugs mirror `/app/backend/brokers/registry.py`.
 */
import {
  Search,       // Accurint
  Fingerprint,  // TLOxp
  Briefcase,    // Work Number
  Gavel,        // PACER
  Scale,        // CourtListener
  Radar,        // Docket Alarm
  FileText,     // UniCourt
  Layers,       // Full Sweep
  Building2,    // Court
  ShieldCheck,  // Employment
  ShieldAlert,  // Bankruptcy
  MapPinned,    // Skip trace
} from "lucide-react";

export const BROKER_META = {
  lexisnexis_accurint: {
    slug: "lexisnexis_accurint",
    label: "Accurint",
    tagline: "Addresses · Employers · Property · Vehicles",
    Icon: Search,
    order: 1,
  },
  tloxp: {
    slug: "tloxp",
    label: "TLOxp",
    tagline: "Identity · Aliases · Associates · Filings",
    Icon: Fingerprint,
    order: 2,
  },
  the_work_number: {
    slug: "the_work_number",
    label: "The Work Number",
    tagline: "Verified Employer + W2 Income",
    Icon: Briefcase,
    order: 3,
  },
  pacer_courtapi: {
    slug: "pacer_courtapi",
    label: "PACER + CourtAPI",
    tagline: "Federal Courts · Bankruptcy",
    Icon: Gavel,
    order: 4,
  },
  courtlistener: {
    slug: "courtlistener",
    label: "CourtListener",
    tagline: "Civil Court History",
    Icon: Scale,
    order: 5,
  },
  docket_alarm: {
    slug: "docket_alarm",
    label: "Docket Alarm",
    tagline: "Recent Docket Activity",
    Icon: Radar,
    order: 6,
  },
  unicourt: {
    slug: "unicourt",
    label: "UniCourt",
    tagline: "State Civil Court Records",
    Icon: FileText,
    order: 7,
  },
};

export const BROKER_SLUGS_ORDERED = Object.values(BROKER_META)
  .sort((a, b) => a.order - b.order)
  .map((b) => b.slug);

export const BUNDLE_META = {
  full_asset_sweep:        { Icon: Layers, tone: "accent" },
  skip_trace:              { Icon: MapPinned, tone: "accent" },
  real_property_deep_dive: { Icon: Building2, tone: "accent" },
  comprehensive_discovery: { Icon: ShieldCheck, tone: "accent" },
};

export const RECOVERY_TONE = (pct) => {
  if (pct >= 70) return "text-success";
  if (pct >= 45) return "text-warning";
  return "text-danger";
};

export const PRIORITY_LABELS = {
  1: "P1 · Fastest Path",
  2: "P2",
  3: "P3",
  4: "P4",
  5: "P5",
  6: "P6",
};
